import * as React from "react";
import {useAuth} from './AuthContext'
import { returnBasenameUrl } from "../utils";

type pravFissesDataType = {
    fetched: boolean
    success: boolean    
    reply?: string
    totalcount?: number
    procstep?: number
    error?: string
    busunits?: number
    modelfisses?:Array<Array<any>>
    

}

function getInitialState():pravFissesDataType { 
    const prfissescontextdata = sessionStorage.getItem('ksrgrb2b_prfisses_context')
    return prfissescontextdata  ? JSON.parse(prfissescontextdata) : {fetched: false, success: false}
}
async function savePrFissesContext(prfissescontextdata: any):Promise<any>{
    sessionStorage.setItem("ksrgrb2b_prfisses_context", JSON.stringify(prfissescontextdata));
}
interface PrFissesContextType {
    prfissescontextdata: pravFissesDataType, 
    setprfissescontext: () => void ;
    clearprfissescontext: () => void ;
}
let PrFissesContext = React.createContext<PrFissesContextType>(null!); // PrAvContextType 

function PrFissesProvider({ children }: { children: React.ReactNode }) {
    let [prfissescontextdata, setPrfissesContextdata] = React.useState<pravFissesDataType>(getInitialState); //  React.useState<any>(null);
    let auth = useAuth();
    console.log("PrAFissesProvider startup, prfissescontextdata=",prfissescontextdata)
    let prfissesData:pravFissesDataType={ 
        fetched: false, 
        success: false,
        error: ""
    }
    React.useEffect(() => {
        sessionStorage.setItem('ksrgrb2b_prfisses_context', JSON.stringify(prfissescontextdata))
    },[prfissescontextdata]);

    let setprfissescontext = () => { 
        console.log("PrAFissesProvider setprfissescontext, called")
        if(auth.userData === undefined || auth.userData === null ||
        auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
        auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false)
        {
            console.log("PrAFissesProvider setPrfissesContextdata, not authenticted")
            setPrfissesContextdata({fetched: true, success: false})
        }
        else {
            /* bypass ajax because it is only 9999 mark for now ... */
            const ms = Date.now();
            // const encodedValue = encodeURIComponent(someVariable);
            // fetch(`https://example.com/foo?bar=${encodedValue}`);
            let basename=returnBasenameUrl()
            let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}&fetch=prfisses&appId=${process.env.REACT_APP_APPID}`;

            console.log("PrAFissesProvider setPrfissesContextdata, fetching context...")

            fetch(url, { method: 'GET' }
            )
            .then((response) =>  {
                if (!response.ok) {
                    console.log('PrAFissesProvider setPrfissesContextdata response not ok=',response)
                    prfissesData.success=false;
                    prfissesData.fetched=true;
                    prfissesData.error="Bad setPrfissesContextdata Response";
                    return {}
                }
                else {
                    console.log('PrAFissesProvider setPrfissesContextdata response ok=',response)
                    return response.json()
                }
            })
            .then((data:any) => {
                console.log('PrAFissesProvider setPrfissesContextdata response data=',data)
                if(data.success===undefined || data.success===null){
                    prfissesData.success=false;
                    prfissesData.fetched=true;
                    prfissesData.error="Bad Json Response";
                    console.log('PrAFissesProvider setPrfissesContextdata response=',"Bad Json Response")
                }
                else {
                    if(data.success===true){
                        console.log('PrAFissesProvider setPrfissesContextdata response=',"data.success===true")
                        prfissesData.success= data.success
                        prfissesData.fetched=true;
                        prfissesData.modelfisses= data.fisses; // data.modelfisses
                        /*
                        {"success":true,
                        "modelfisses":[
                            {"brand":"DUCATI",
                            "model":"DUCATI Pandah",
                            "fisses":[
                                {"image":"https:\/\/b2bksrgr.local\/images\/fiss\/model001\/E05.gif",
                                "imageLabel":"E05",
                                "imagename":"e05",
                                "width":"1120",
                                "height":"640",
                                "areas":[
                                    {"shape":"circle","alt":"img0","coords":"66,23,12"},
                                    {"shape":"circle","alt":"img1","coords":"111,43,13"},
                                    {"shape":"circle","alt":"img2","coords":"169,65,13"},
                                    {"shape":"circle","alt":"img3","coords":"206,92,12"},
                                    {"shape":"circle","alt":"img4","coords":"271,116,16"}
                                ]}
                            ]}
                        ]
                        }
                        */
                    }
                    else {
                        console.log('PrAFissesProvider setPrfissesContextdata response=',"data.success===false")
                    }
                }
            })
            .catch((err) => {
                console.log("PrAFissesProvider setPrfissesContextdata exception=",err.message);
                prfissesData.success=false;
                prfissesData.fetched=true;
                prfissesData.error="PrAFissesProvider setPrfissesContextdata exception";        
            })
            .finally(() => {
                // console.log("PrAFissesProvider finally: ", pravData)            
                setPrfissesContextdata(prfissesData);                
            })   
        }
    };
    let clearprfissescontext = () => {
        setPrfissesContextdata({fetched: false ,success: false})
    };
        
    let value = { prfissescontextdata, setprfissescontext, clearprfissescontext };
    return <PrFissesContext.Provider value={value}>{children}</PrFissesContext.Provider>;

}
function usePrFissescontext() {
    return React.useContext(PrFissesContext);
}

export {PrFissesProvider, PrFissesContext, usePrFissescontext}
